export default {
  name: 'Header section - 13',
  tab: 'header',
  type: 'navigation-default-section',
  content: {
    logo: '/storage/media/Logo/combination_logo_pink.svg',
    menu: 'default'
  },
  design: {
    'background-color': 'var(--accent-color)',
    padding: '15px',
    'logo-width': '150px',
    'menu-font-family': 'inherit',
    'menu-text-color': 'var(--secondary-color)',
    'menu-font-size': '14px'
  },
  layout: {
    'content-container-fluid': '1',
    centered: '0',
    absolute: '0',
    'absolute-background-opacity': '0',
    'show-toggle': 'lg'
  },
  advanced: {
    'stick-on-scroll': '0',
    'sticky-background-color': 'var(--primary-color)',
    'sticky-background-opacity': '1',
    'active-style': 'default'
  }
}
